import { HermesAnalytics, DynatraceClient } from '@workivate/tho-web-shared';
import { isManulifeEventsEnabled } from './helpers';
import { getRegionalApiEndpoints } from 'globals/regional-api';
import { getAuthenticationHeader } from 'globals/fetch.helpers';
import version from 'version';

const instance = HermesAnalytics.ManulifeEngine({
  endpoint: () =>
    `${getRegionalApiEndpoints().services}/click-tracker/tracking-batches`,
  appVersion: version.version,
  getAuthHeader: getAuthenticationHeader,
  getSessionId: DynatraceClient.getSessionId,
  isEnabled: isManulifeEventsEnabled,
});

export default instance;
